import { authPost, authGet, authPut } from '../auth/authFetches';
import { FileMetadata, PresignedURL, GetPresignedURLsResponse, FileMetadataUpdate } from '@/interfaces/types';

export async function removeFile(accessToken: string, filename: string) {
  const path = `/files/removeFile`;
  return await authPost(accessToken, path, { filename });
}

export async function getFilelist(accessToken: string) {
  const path = '/files/get-filelist';
  return await authGet(accessToken, path);
}

export async function getPresignedURLs(
  accessToken: string,
  files: FileMetadata[],
  bucketName: string,
  uploadedBy?: string
): Promise<GetPresignedURLsResponse> {
  const path = '/files/generate-presigned-urls';
  const params = { files, bucketName, uploadedBy };
  return (await authPost(accessToken, path, params)) as GetPresignedURLsResponse;
}

export async function notifyFileUpload(
  accessToken: string,
  filename: string,
  functionName: string
) {
  const path = '/files/notify-upload';
  const params = { filename, functionName };
  return await authPost(accessToken, path, params);
}

export const getFileDownloadUrl = async (accessToken: string, filename: string): Promise<{ 
  url: string; 
  filename: string; 
  uploadMetadata?: { 
    uploadedBy: string; 
    uploadedAt: string;
    wentThrough?: boolean;
    failureReason?: string;
    client?: string;
    lawyers?: string[];
    date?: string;
  } 
}> => {
  const path = `/files/download-url/${encodeURIComponent(filename)}`;
  return await authGet(accessToken, path);
};

export const updateFileMetadata = async (accessToken: string, metadata: FileMetadataUpdate) => {
  const path = '/files/update-metadata';
  return await authPut(accessToken, path, metadata);
};

export const batchDownloadFiles = async (accessToken: string): Promise<void> => {
  const response = await authGet(accessToken, '/files/batch-download');
  const a = document.createElement('a');
  a.href = response.url;
  a.download = 'all-files.zip';
  document.body.appendChild(a);
  a.click();
  a.remove();
};
